// extracted by mini-css-extract-plugin
export var hotelButtonsContainer = "Hotel-module--hotelButtonsContainer--a47af";
export var hotelButtonsLink = "Hotel-module--hotelButtonsLink--bcddf";
export var hotelButtonsLinkText = "Hotel-module--hotelButtonsLinkText--13663";
export var hotelDetailsAmount = "Hotel-module--hotelDetailsAmount--63d1c";
export var hotelDetailsDays = "Hotel-module--hotelDetailsDays--dceb2";
export var hotelDetailsPerson = "Hotel-module--hotelDetailsPerson--ed5c4";
export var hotelDetailsPrice = "Hotel-module--hotelDetailsPrice--a230e";
export var hotelDetailsSave = "Hotel-module--hotelDetailsSave--4dbce";
export var hotelDetailsTax = "Hotel-module--hotelDetailsTax--62640";
export var hotelDetailsWas = "Hotel-module--hotelDetailsWas--3a701";
export var hotelHeading = "Hotel-module--hotelHeading--6c08f";
export var hotelHeading__text = "Hotel-module--hotelHeading__text--72598";
export var hotelPriceDetails = "Hotel-module--hotelPriceDetails--6ffb6";
export var hotelRatingsContainer = "Hotel-module--hotelRatingsContainer--9a3b7";
export var icon = "Hotel-module--icon--00ec6";